export default function UserIcon({ width="15px", stroke="#667085", fill= "#667085"}) {
  return (
    <svg
      width={width}
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9697 17.0303C16.2626 17.3232 16.7374 17.3232 17.0303 17.0303C17.3232 16.7374 17.3232 16.2626 17.0303 15.9697L15.9697 17.0303ZM13.4053 12.3447C13.1124 12.0518 12.6376 12.0518 12.3447 12.3447C12.0518 12.6376 12.0518 13.1124 12.3447 13.4053L13.4053 12.3447ZM14.0833 8.16667C14.0833 11.4344 11.4344 14.0833 8.16667 14.0833V15.5833C12.2628 15.5833 15.5833 12.2628 15.5833 8.16667H14.0833ZM8.16667 14.0833C4.89898 14.0833 2.25 11.4344 2.25 8.16667H0.75C0.75 12.2628 4.07055 15.5833 8.16667 15.5833V14.0833ZM2.25 8.16667C2.25 4.89898 4.89898 2.25 8.16667 2.25V0.75C4.07055 0.75 0.75 4.07055 0.75 8.16667H2.25ZM8.16667 2.25C11.4344 2.25 14.0833 4.89898 14.0833 8.16667H15.5833C15.5833 4.07055 12.2628 0.75 8.16667 0.75V2.25ZM17.0303 15.9697L13.4053 12.3447L12.3447 13.4053L15.9697 17.0303L17.0303 15.9697Z"
        fill={fill}
      />
    </svg>
  );
}
